/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@dm/ang';
import { CoreModule } from '@dm/core';

import { DetailCheckResultUpgradeModule } from '../detail-check-result-upgrade/detail-check-result-upgrade.module';
import { UpgradeService } from '../upgrade.service';
import { UpgradeStrService } from '../upgrade-str.service';
import { SystemUpgradeComponent } from './system-upgrade.component';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        CoreModule,
        DetailCheckResultUpgradeModule,
    ],
    declarations: [
        SystemUpgradeComponent,
    ],
    providers: [
        SystemUpgradeComponent,
        UpgradeStrService,
        UpgradeService,
    ],
    exports: [SystemUpgradeComponent],
})

export class SystemUpgradeModule { }
